import { useState } from 'react'
import { Modal } from './Modal'
import { HeaderModal } from './Header'
import { Body } from './Body'
import { FooterModal } from './Footer'
import closeIcon from 'assets/images/close-icon.svg';
import { InputTextField } from 'components/InputField'

const OverwriteModal = ({
    draftTitle,
    headerText,
    bodyText,
    setShowOverwriteModal,
    confirmNew,
    confirmOverwrite,
    cancel,
    btnGroup,
    allTemplateTitles
}: any) => {
    const [isShow, setisShow] = useState(true);
    const [title, setTitle] = useState<any>(draftTitle || '')
    const [showErrorMessage, setShowErrorMessage] = useState(false)
    const defaultTitle = draftTitle?.toLowerCase() || ''
    const onCloseModal = () => {
        setisShow(false);
    }

    const handleTitleChange = (e: any) => {
        setTitle(e.target.value)
    }

    const save = (type: any, value: any) => {
        const theTitle = value?.trim()?.toLowerCase()
        
        if (type == 'create') {
            if (allTemplateTitles.includes(theTitle)) {
                setShowErrorMessage(true)
                return;
            }
            setShowErrorMessage(false)
            confirmNew(value)
        }
        if (type == 'overwrite') {
            if (allTemplateTitles.includes(theTitle) && theTitle !== defaultTitle) {
                setShowErrorMessage(true)
                return;
            }
            setShowErrorMessage(false)
            confirmOverwrite(value)
        }
    }

    return (
        <>
            <Modal className={"modal-wrapper max-w-[400px]"} isShow={setShowOverwriteModal}>
                <div>
                    <HeaderModal title={"test"} isShowHeader={true} className="modal-header pt-5 px-6">
                        <div className="flex items-center justify-between pb-3">
                            <h2 className="text-lg text-[#101828] font-interSemiBold leading-none pb-1.5">{headerText}</h2>
                            {/* Close Icon */}
                            <img
                                className="modal-close modal-toggle cursor-pointer hover:bg-[#f2f4f7] rounded w-5 p-1 -mt-[10px]"
                                id="modal-toggle"
                                src={closeIcon}
                                onClick={() => { setShowOverwriteModal(false); cancel() }}
                                alt="close icon"
                            />
                        </div>
                        <div className='mb-5'>
                            <label className='text-[15px] text-[#344054] font-interMedium pb-1.5 inline-block' htmlFor="">Name</label>
                            <InputTextField
                                className="placeholder:text-[#344054] placeholder:text-base text-base text-[#344054] w-full"
                                name={"name"}
                                placeholder={"Enter program name"}
                                onChange={handleTitleChange}
                                value={title}
                            />
                            <span className='block pt-1 text-sm'>Give it a custom name for you to associate easily</span>
                            {
                                showErrorMessage &&
                                <span className='block pt-1 text-sm text-[red]'>This title already exists</span>
                            }
                        </div>

                        {
                            bodyText &&
                            <p className='text-[#101828] pb-4'>{bodyText}</p>
                        }
                    </HeaderModal>
                    <Body title="" isShowBody={true} className="modal-body px-3 pt-1">
                        <div className="modal-select-box fete-settings-modals">

                        </div>
                    </Body>

                    <FooterModal title="" isShowFooter={true} className="modal-footer px-6 pb-6">
                        <div className="flex items-center gap-x-3 justify-center">
                            {
                                btnGroup == 'isEditMode' &&
                                <>
                                    <button
                                        // onClick={() => confirmOverwrite(title)}
                                        onClick={() => save('overwrite', title)}
                                        className={`text-[#344054] hover:bg-[#F2F4F7] font-interSemiBold border border-[#D0D5DD] rounded-lg tracking-wide py-2.5 px-3.5 !text-base flex-1 ${!title ? 'button-disabled' : ''}`}
                                        disabled={title ? false : true}
                                    >
                                        Overwrite
                                    </button>
                                    <button
                                        // onClick={() => confirmNew(title)}
                                        onClick={() => save('create', title)}
                                        className={`!text-base text-white bg-[#1E0AF5] hover:bg-[#120693] font-interSemiBold rounded-lg  px-3.5 py-2.5 flex-1 ${!title ? 'button-disabled' : ''} `}
                                        disabled={title ? false : true}
                                    >
                                        Create New
                                    </button>
                                </>
                            }
                            {
                                btnGroup == 'isCreateMode' &&
                                <>
                                    <button
                                        onClick={() => { setShowOverwriteModal(false); cancel() }}
                                        className="text-[#344054] font-interSemiBold border border-[#D0D5DD] rounded-lg tracking-wide py-2.5 px-3.5 !text-base flex-1">
                                        Cancel
                                    </button>
                                    <button
                                        // onClick={() => confirmNew(title)}
                                        onClick={() => save('create', title)}
                                        className={`!text-base text-white bg-[blue] font-interSemiBold rounded-lg  px-3.5 py-2.5 flex-1 ${!title ? 'button-disabled' : ''} `}
                                        disabled={title ? false : true}
                                    >
                                        Save
                                    </button>
                                </>
                            }
                        </div>
                    </FooterModal>
                </div>

            </Modal>
        </>
    )
}

export default OverwriteModal;
